export default __webpack_public_path__ + "1b6719308cdf00bf569861c9ad93e2f4.png";